import { createFileRoute } from "@tanstack/react-router";

import { AdminHypermem } from "@/features/admin";
import { HM_TAB_IDS, type HmTabId } from "@/features/admin/components/AdminHypermem";

/**
 * HyperMem admin — cognitive-memory governance shell.
 *
 * URL contract
 * ------------
 * - ``?tab=<overview|traces|…>`` persists the active sub-tab so deep-links
 *   (audit rows, Linear tickets) land on the right tab and refresh/back keep
 *   the operator in place. Unknown values coerce to ``"overview"``.
 * - ``?trace=<turn_id>&traceUser=<user_id>`` opens the Reasoning-Traces
 *   detail as a dedicated in-page SECTION (a place you navigate to, not a
 *   drawer). Both are read inside ``HmReasoningTracesTab``.
 */
interface HypermemSearch {
  readonly tab: HmTabId;
  readonly trace?: string;
  readonly traceUser?: string;
}

export const Route = createFileRoute("/_authed/_modal/admin/hypermem")({
  component: AdminHypermem,
  validateSearch: (raw: Record<string, unknown>): HypermemSearch => {
    const candidate = typeof raw.tab === "string" ? raw.tab : "";
    const tab = (HM_TAB_IDS as readonly string[]).includes(candidate)
      ? (candidate as HmTabId)
      : "overview";
    return {
      tab,
      trace: typeof raw.trace === "string" ? raw.trace : undefined,
      traceUser: typeof raw.traceUser === "string" ? raw.traceUser : undefined,
    };
  },
});
